import { AdminAppStats, GetStentorEventsReturn } from "api";
import { ClientApp } from "models";

export interface AdminErrors {
    [action: string]: Error;
}

export type AdminState = {
    asUser?: boolean;
    apps?: ClientApp[];
    currentApp?: ClientApp;
    appStats?: AdminAppStats;
    stentorEvents?: GetStentorEventsReturn;
    error?: AdminErrors;
};
